<script>
import { mapActions, mapGetters } from 'vuex';
import api from '@/helpers/api';
import StatusTypes from '../../../helpers/enums/statusTypes.enum';

export default {
  data() {
    return {
      appClosingBlocks: [
        'uploadAiFiles',
        'deleteAiFiles',
      ],
    };
  },
  computed: {
    ...mapGetters({
      backgroundActions: 'automation/backgroundActions',
    }),
  },
  watch: {
    backgroundActions() {
      const pendingActions = this.backgroundActions.filter(ba => ba.status === StatusTypes.PENDING);
      if (pendingActions.length) {
        // const runActions = this.backgroundActions.toReversed();
        pendingActions.forEach((action) => {
          if (action.action === 'uploadAiFiles' && action.data && action.data.files && action.data.files.length > 0) {
            this.backgroundActionStatusChange({
              action: 'uploadAiFiles',
              assistantId: action.assistantId,
              status: StatusTypes.RUNNING,
            });
            let fileUploadGroupId = null;

            const groupUploadEndpoint = `organisation/${this.currentOrganisation.id}/assistant/${action.assistantId}/file/upload-group`;
            api('POST', groupUploadEndpoint, { number_of_files: action.data.files.length }, null, 'w')
              .then((response) => {
                fileUploadGroupId = response.data.file_upload_group_id;
                this.uploadBackgroundAiFilesVUEX({
                  id: action.id,
                  assistantId: action.assistantId,
                  files: action.data.files,
                  fileUploadGroupId,
                });
              });
          } else if (action.action === 'deleteAiFiles' && action.data && action.data.files && action.data.files.length > 0) {
            this.backgroundActionStatusChange({
              action: 'deleteAiFiles',
              assistantId: action.assistantId,
              status: StatusTypes.RUNNING,
            });
            let fileDeleteGroupId = null;

            const groupDeleteEndpoint = `organisation/${this.currentOrganisation.id}/assistant/${action.assistantId}/file/delete-group`;
            api('POST', groupDeleteEndpoint, { number_of_files: action.data.files.length }, null, 'w')
              .then((response) => {
                fileDeleteGroupId = response.data.file_delete_group_id;
                this.removeBackgroundAiFilesVUEX({
                  id: action.id,
                  assistantId: action.assistantId,
                  files: action.data.files,
                  fileDeleteGroupId,
                });
              });
          }
          // if (action.action === 'webScrape') {
          //   this.backgroundActionStatusChange({
          //     action: 'webScrape',
          //     assistantId: action.assistantId,
          //     status: StatusTypes.RUNNING,
          //   });
          // }
        });
      }
    },
  },
  created() {
    // Code to run when the component is created


    // WATCHER FOR PUSHER EVENTS
  },
  mounted() {
    const closeHandler = (e) => {
      const defaultMessage = 'Changes that you made may not be saved.';
      if (this.checkAppClosingBlocks()) {
        e.preventDefault(); // required in some browsers
        e.returnValue = defaultMessage; // required in some browsers
        return defaultMessage; // only works in old browsers
      }
      return false;
    };

    if (window.addEventListener) {
      window.addEventListener('beforeunload', closeHandler, true);
      window.addEventListener('close', closeHandler, true);
    } else if (window.attachEvent) {
      window.attachEvent('onbeforeunload', closeHandler);
      window.addEventListener('close', closeHandler);
    }
  },
  methods: {
    ...mapActions({
      uploadBackgroundAiFilesVUEX: 'automation/uploadBackgroundAiFiles',
      removeBackgroundAiFilesVUEX: 'automation/removeBackgroundAiFiles',
      backgroundActionStatusChange: 'automation/backgroundActionStatusChange',
    }),
    /**
     * Method will check all the store variables listed as blockers to determine if the closing or reloading of the page is allowed.
     * User is still available to force the close/reload but it will get the native info popup first.
     */
    checkAppClosingBlocks() {
      return this.appClosingBlocks.some(blocker => this.backgroundActions.filter(ba => ba.action === blocker && [StatusTypes.PENDING, StatusTypes.RUNNING].includes(ba.status)).length > 0);
    },
  },
};
</script>
